import { StyleSheet, View } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	list: {
		marginBottom: 8,
		paddingLeft: 12,
		lineHeight: 1.4,
		flexDirection: 'column',
	},
})

const List = ({ children }: { children: React.ReactNode }) => {
	return (
		<ErrorBoundary message={'Error in List'}>
			<View style={styles.list}>{children}</View>
		</ErrorBoundary>
	)
}

export default List
